export const mergeVisibleColumnOrder = (stableColumnOrder: string[], reorderedVisibleKeys: string[]): string[] => {
  const visibleKeySet = new Set(reorderedVisibleKeys);
  let visibleIndex = 0;
  const mergedOrder = stableColumnOrder.map(key =>
    visibleKeySet.has(key) ? reorderedVisibleKeys[visibleIndex++] : key,
  );

  mergedOrder.push(...reorderedVisibleKeys.slice(visibleIndex));
  return mergedOrder;
};

export const applyPreferredOrder = (items: string[], preferredOrder: string[]): string[] => {
  if (preferredOrder.length === 0) return items;
  const itemSet = new Set(items);
  const orderedSet = new Set(preferredOrder);
  return [...preferredOrder.filter(item => itemSet.has(item)), ...items.filter(item => !orderedSet.has(item))];
};
